import { ContactType, HistorySearchEnum, HistorySearchType } from "../../../../interfaces/general";

import { ReactComponent as TrashIcon } from "../../../../assets/images/icons/trash-red.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/images/icons/Close X.svg";
import { searchTypeOptions } from "../../../../utils/component/fileManagers/searchFileManager/searchFileManager.index";
import moment from "moment-jalaali";
import { dateOptions, searchUrlToString } from "../../../../scripts/helpers";
import { useEffect, useRef, useState, Dispatch, SetStateAction } from "react";
import API from "../../../../urls/api";
import { advancedResponseValidator, del, getAll, responseValidator } from "../../../../scripts/api";
import { useNavigate } from "react-router-dom";
import PATH from "../../../../urls/path";
import { SearchPageType } from "./search.interface";
import useLazyLoad from "../../../../scripts/hooks/useLazyload";
import Loader from "../../../../utils/component/loader/loader.index";
import { toast } from "mobin-toast";

const HistorySearch = ({
    handleClearSearch,
    setOpen
}: {
    handleClearSearch: (keepValue?: boolean) => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
    const ref = useRef<any>();
    const navigate = useNavigate();
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [contactList, setContactList] = useState<ContactType[]>([]);
    const { list, setList, loading } = useLazyLoad<HistorySearchType>({ ref, url: API.reporting.getHistorySearch() });

    useEffect(() => {
        if (list && list.length) {
            getAll((list, status) => {
                if (responseValidator(status)) setContactList(list.result);
            }, API.contact.list());
        }
    }, [list]);

    const navigateToSearch = (item: HistorySearchType) => {
        const qs = searchUrlToString(JSON.parse(item.content));
        const pageType = item.type === HistorySearchEnum.MINE ? SearchPageType.MY_FILE : SearchPageType.WITH_SHARE_ME;
        navigate(`${PATH.search}${qs}pageType:${pageType}`);
        handleClearSearch(true);
    };

    const clearAllHistory = async () => {
        setDeleteLoading(true);
        del((data, status) => {
            if (advancedResponseValidator(data, status)) {
                setOpen(false);
                toast({ title: "تمامی جستجوهای شما با موفقیت حذف شدند", type: "success" });
            }
            setDeleteLoading(false);
        }, API.reporting.deleteAllHistorySearch());
    };

    const clearHistory = (item: HistorySearchType) => {
        setDeleteLoading(true);
        del(
            (data, status) => {
                if (advancedResponseValidator(data, status)) {
                    setList((prev) => prev?.filter((f) => f.id !== item.id));
                    toast({ title: "جستجوی شما با موفقیت حذف شد", type: "success" });
                }
                setDeleteLoading(false);
            },
            API.reporting.deleteHistorySearch(undefined, item.id)
        );
    };

    return (
        <div className={`${deleteLoading ? "opacity-50 pointer-events-none" : ""}`}>
            {!list ? (
                <div className={`flex items-center justify-center`}>
                    <Loader hiddenLogo />
                </div>
            ) : list.length ? (
                <div className="flex flex-col -mb-2">
                    <div className="flex items-center justify-between pt-2 pb-4 px-4 sm:px-6">
                        <p className="font-medium text-sm text-secondary-800">آخرین جستجوهای شما</p>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                clearAllHistory();
                            }}
                            className="size-6 [&>svg]:size-full shrink-0"
                        >
                            <TrashIcon />
                        </button>
                    </div>

                    <hr className="border-secondary-300" />

                    <ul className="flex flex-col divide-y divide-secondary-300">
                        {list.map((item) => {
                            const value = JSON.parse(item.content);

                            return (
                                <li
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigateToSearch(item);
                                    }}
                                    key={item.created_at + item.content}
                                    className="px-4 sm:px-6 py-4 sm:py-5 flex flex-col gap-2 cursor-pointer"
                                >
                                    {!!value.name && (
                                        <div className="flex items-center justify-between gap-2">
                                            <p className="font-bold text-secondary-900 sm:text-secondary-800 line-clamp-1">{value.name}</p>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    clearHistory(item);
                                                }}
                                                className="size-4 sm:size-5 [&>svg]:size-full shrink-0"
                                            >
                                                <CloseIcon />
                                            </button>
                                        </div>
                                    )}

                                    <div className="flex items-start justify-between gap-2">
                                        <div className="flex items-center justify-start flex-wrap gap-2 flex-1">
                                            <HistoryBox label={item.type === HistorySearchEnum.MINE ? "فایل های من" : "مشترک با من"} />
                                            <HistoryBox label={value.parent_name ? `پوشه "${value.parent_name}"` : undefined} />
                                            <HistoryBox label={searchTypeOptions.find((option) => option.payload === value.type)?.label || "همه"} />
                                            <HistoryBox label={dateParser(value)} />
                                            <HistoryBox label={contactParser(value.owners_id, contactList)} />
                                            <HistoryBox label={value.is_trash ? "سطل زباله" : undefined} />
                                            <HistoryBox label={value.is_favorite ? "علاقه مندی" : undefined} />
                                        </div>

                                        {!value.name && (
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    clearHistory(item);
                                                }}
                                                className="size-4 sm:size-5 [&>svg]:size-full shrink-0"
                                            >
                                                <CloseIcon />
                                            </button>
                                        )}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ) : (
                <p className="text-sm font-medium px-4 pt-2 text-secondary-800">لطفا نام فایل یا پوشه مورد نظر را وارد کنید.</p>
            )}

            <div ref={ref} className={`flex items-center justify-center py-1 `}>
                {!!list && loading && <Loader hiddenLogo />}
            </div>
        </div>
    );
};

export default HistorySearch;

const HistoryBox = ({ label }: { label?: string }) => {
    if (!label) return <></>;
    return (
        <div
            title={label}
            className="line-clamp-1 border leading-[30px] border-gray-200 bg-gray-100 rounded px-3 text-secondary-800 font-normal text-sm"
        >
            {label}
        </div>
    );
};

const dateParser = (value: any) => {
    let date: string | undefined;
    if (value.from_created_at && value.to_created_at) {
        const findDate = dateOptions.find(({ payload }) =>
            payload
                ? moment.unix(payload[0]).diff(moment.unix(value.from_created_at), "day") === 0 &&
                  moment.unix(payload[1]).diff(moment.unix(value.to_created_at), "day") === 0
                : false
        );

        if (findDate) date = findDate.label;
        else
            date = `${moment.unix(value.from_created_at).format("jDD jMMMM jYYYY")} تا ${moment.unix(value.to_created_at).format("jDD jMMMM jYYYY")}`;
    }

    return date;
};

const contactParser = (owners_id: any, contactList: ContactType[]) => {
    const owners = owners_id && contactList.length ? String(owners_id).split(",") : [];

    if (!owners.length) return undefined;

    const contacts = owners.reduce((acc: string, owner: string) => {
        const contact = contactList.find((contact) => contact.contact_id === Number(owner));
        if (contact) acc += contact.name + ", ";
        return acc;
    }, "");

    return contacts.endsWith(", ") ? contacts.slice(0, -2) : contacts;
};
